export const TalkbackIcon = () => (
  <svg
    tabIndex={-1}
    focusable="false"
    className="svg-icon icon-talkback"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle className="secondary-path" cx="12" cy="12" r="12" fill="none" stroke="none" />
    <path
      tabIndex={-1}
      className="primary-path"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5C13.1046 5 14 5.84615 14 6.89474V11.6316C14 12.6802 13.1046 13.5263 12 13.5263C10.8954 13.5263 10 12.6802 10 11.6316V6.89474C10 5.84615 10.8954 5 12 5ZM16 9.26316C15.7239 9.26316 15.5 9.47927 15.5 9.74561V11.6316C15.5 13.4651 13.933 14.9474 12 14.9474C10.067 14.9474 8.5 13.4651 8.5 11.6316V9.74561C8.5 9.47927 8.27614 9.26316 8 9.26316C7.72386 9.26316 7.5 9.47927 7.5 9.74561V11.6316C7.50099 13.7196 9.16704 15.4684 11.3333 15.7018V16.8421H10C9.72386 16.8421 9.5 17.0582 9.5 17.3246C9.5 17.5909 9.72386 17.807 10 17.807H14C14.2761 17.807 14.5 17.5909 14.5 17.3246C14.5 17.0582 14.2761 16.8421 14 16.8421H12.6667V15.7018C14.833 15.4684 16.499 13.7196 16.5 11.6316V9.74561C16.5 9.47927 16.2761 9.26316 16 9.26316Z"
      fill="none"
    />
  </svg>
);
